import { FC, ReactNode, useMemo } from "react";
import { createPortal } from "react-dom";

export interface ModalModelProps {
  children: ReactNode;
}

export const Modal: FC<ModalModelProps> = ({ children }) => {
  const containerElement = useMemo<Element | null>(
    () => document.getElementById("modal-container"),
    []
  );
  if (!containerElement) {
    throw new Error("Modal container element not found");
  }
  return createPortal(children, containerElement);
};
